import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import Button from '../../../../components/components-ui/Button/Button'
import { Grid, Col } from '../../../../components/Grid'
import api from '../../../../services/Api'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { useParams, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

function Action() {
  const [material, setMaterial] = useState('')

  const { id } = useParams()

  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg)
    } else {
      toast.error(msg)
    }
  }

  async function createMaterial(values) {
    const response = await api.post('/material/create/', {
      material: values.nome_material,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      return
    }
    showAlert(1, response.data.msg)
  }

  async function editarMaterial(values) {
    const response = await api.put(`/material/edit/${id}`, {
      material: values.nome_material,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      return
    }
    showAlert(1, response.data.msg)
  }

  useEffect(() => {
    async function getMaterial() {
      const response = await api.get(`/material/show/${id}`)
      setMaterial(response.data.material)
    }
    getMaterial()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate()
  const validadtionSchema = Yup.object().shape({
    nome_material: Yup.string().required('*Campo Obrigatório'),
  })
  return (
    <Container>
      <h3> {id ? 'Edição de Material' : 'Cadastro de Material'} </h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{ nome_material: material }}
          enableReinitialize={true}
          onSubmit={
            id
              ? (values) => editarMaterial(values)
              : (values) => createMaterial(values)
          }
          validationSchema={validadtionSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid>
                <Col size={12}>
                  <label> Nome Material </label>
                  <Field type="text" name="nome_material" />
                  {errors.nome_material && touched.nome_material ? (
                    <span className={styles.alertError}>
                      {errors.nome_material}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <Button type="submit" title={'Salvar'} />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate('/usina/material')
                    }}
                  />
                </Col>
              </Grid>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  )
}

export default Action
